import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Pet } from '../../../services/api';
import { getCustomIcon } from '../../../utils/customIcons';

interface FormSkellyProps {
  availablePets: Pet[];
}

const FormSkelly: React.FC<FormSkellyProps> = ({ availablePets }) => {
  const theme = useTheme();

  return (
    <Box sx={{ opacity: 0.6, pointerEvents: 'none' }}>
      <Box
        sx={{
          height: '2rem',
          mb: '1rem',
          borderBottom: `3px dashed ${theme.palette.dividerContrast}`,
          '@media (max-width: 600px)': {
            height: '1rem',
            mb: '1rem',
          },
        }}
      />

      <Box
        sx={{
          padding: '.75rem 0',
          mb: '.5rem',
          backgroundColor: theme.palette.primary.main,
        }}
      >
        <Typography
          sx={{
            lineHeight: '1.6rem',
            fontSize: '2rem',
            fontWeight: 700,
            pl: '1rem',
            color: theme.palette.grey[100],
          }}
        >
          Pets*
        </Typography>
      </Box>

      {availablePets.map((pet) => (
        <Box
          key={pet.id}
          sx={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            padding: '0.65rem 1rem',
            borderBottom: `3px dashed ${theme.palette.dividerContrast}`,
          }}
        >
          {getCustomIcon(pet.petType?.type, '2.5rem')}
          <Typography
            sx={{
              lineHeight: '1.6rem',
              fontSize: '2rem',
              fontWeight: 700,
              pl: '1rem',
              color: theme.palette.grey[900],
            }}
          >
            {pet.name}
          </Typography>
          <Typography
            sx={{
              lineHeight: '1.6rem',
              fontSize: '2rem',
              fontWeight: 500,
              pl: '1rem',
              color: theme.palette.grey[900],
            }}
          >
            {' '}
            - {pet.petBreed?.breed || pet.petType?.type}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default FormSkelly;
